import React from 'react'
import { useTranslation } from 'react-i18next'

import { IconS24Crane224 } from '@is24/cosma-ui-icons'
import { ConstructionScreenValidationResult } from '../../../../../../@types/validation-types'
import { InsertionFlowScreensProps } from '../../../../../../@types/props-types'
import EnergyCertificate from '../energyCertificate/EnergyCertificate'
import { SCREEN_CONSTRUCTION, SCREENS } from '../../../../../../services/domain/wizardScreens'
import ScreenContainer from '../../../../../common/containers/screenContainer/ScreenContainer'
import { ScreenLayout } from '../../../../../common/containers/screenLayout/ScreenLayout'
import ConstructionConditionField from '../fields/constructionConditionField/ConstructionConditionField'
import LastModernizationField from '../../commonFields/lastModernizationField/LastModernizationField'
import ConstructionYearField from '../../commonFields/constructionYearField/ConstructionYearField'
import HeatingTypeField from '../../commonFields/heatingType/HeatingTypeField'
import { getDefaultClasses } from '../../../../../../utils/style-utils'
import EnergySourceField from '../fields/energySourceField/EnergySourceField'
import LabelWithTooltip from '../../basicInfo/fields/common/LabelWithTooltip'
import EnergyCertificatePopoverContent from './EnergyCertificatePopoverContent'

const screen = SCREENS[SCREEN_CONSTRUCTION]
type AdditionalConstructionProps = {
  hasLastModernizationField?: boolean
}
const WebViewConstruction: React.FC<
  InsertionFlowScreensProps<ConstructionScreenValidationResult> & AdditionalConstructionProps
> = ({ insertionData, validationMessages, onChange, doReset, onNavigate, hasLastModernizationField }) => {
  const { t } = useTranslation()

  return (
    <ScreenContainer containerId={screen.id} onNavigate={onNavigate} screen={screen} className=''>
      <ScreenLayout
        id={`${screen.id}-desk-tooltip`}
        headline={'wizard.screen.construction.header'}
        className='grid gutter-vertical-l'
        headerIcon={<IconS24Crane224 />}
        screenName={screen.name}
      >
        <ConstructionConditionField
          insertionData={insertionData}
          onChange={onChange}
          screenName={screen.name}
          showLabelWithTooltip
          wrapperClassName={getDefaultClasses('full')}
        />
        {hasLastModernizationField && (
          <LastModernizationField
            insertionData={insertionData}
            validationMessages={validationMessages}
            onChange={onChange}
            screenName={screen.name}
            wrapperClassName={getDefaultClasses('full')}
            showLabelWithTooltip
          />
        )}
        <HeatingTypeField
          insertionData={insertionData}
          screenName={SCREENS[SCREEN_CONSTRUCTION].name}
          onChange={onChange}
          wrapperClassName={getDefaultClasses('full')}
        />
        <EnergySourceField
          insertionData={insertionData}
          onChange={onChange}
          screenName={screen.name}
          wrapperClassName={getDefaultClasses('full')}
          showLabelWithTooltip
        />
        <ConstructionYearField
          insertionData={insertionData}
          validationMessages={validationMessages}
          onChange={onChange}
          screenName={screen.name}
          wrapperClassName={getDefaultClasses('full')}
          showToggle
        />
        <div className='grid-item one-whole'>
          <LabelWithTooltip
            inputId='total-floors'
            labelText={t('wizard.screen.construction.hasEnergyCertificate')}
            tooltipContent={<EnergyCertificatePopoverContent />}
            showMandatory={false}
            arrowPosition='left'
            containerClassName='margin-bottom-xs'
          />
          <EnergyCertificate
            screenId={screen.id}
            insertionData={insertionData}
            validators={validationMessages!}
            onEnergyCertificateChange={(field, value) => onChange({ screen: screen.name, property: field }, value)}
            doReset={doReset!}
          />
        </div>
      </ScreenLayout>
    </ScreenContainer>
  )
}

export default WebViewConstruction
